<template>
  <a-modal
    width="75%"
    :title="title"
    :visible="innerVisible"
    @cancel="handleCancel"
    cancelText="关闭"
    :okButtonProps="{ style: { display: 'none' } }"
  >
    <a-form layout="inline">
      <a-row :gutter="12">
        <a-col :md="6" :sm="12">
          <a-form-item label="用户编号">
            <a-input v-model="query.userNo" placeholder="请输入用户编号" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item label="分类编码">
            <a-input v-model="query.classNo" placeholder="请输入分类编码" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item label="水表编号">
            <a-input v-model="query.appearanceNo" placeholder="请输入水表编号" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item>
            <a-button type="primary" @click="loadData">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
            <a-button type="primary" style="margin-left: 8px" @click="revertAll">一键还原</a-button>
            <a-button type="danger" style="margin-left: 8px" @click="clearUp">一键清空回收站</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-alert type="info" showIcon style="margin-bottom: 16px; margin-top: 16px">
      <template slot="message">
        <span>已选择</span>
        <a style="font-weight: 600; padding: 0 4px">{{ selectedRowKeys.length }}</a>
        <span>项</span>
        <template v-if="selectedRowKeys.length > 0">
          <a-divider type="vertical" />
          <a @click="handleClearSelection">清空选择</a>
          <a-divider type="vertical" />
          <a @click="handleRevertBatch">批量还原</a>
          <a-divider type="vertical" />
          <a @click="handleDeleteBatch">批量删除</a>
        </template>
      </template>
    </a-alert>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="pagination"
      :rowSelection="{ selectedRowKeys, onChange: handleTableSelectChange }"
      :scroll="{ x: 2000 }"
      @change="pageChange"
    >
      <span slot="bookId" slot-scope="text">{{ bookObj[text] }}</span>

      <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag>
      <a-tag color="blue" slot="natureOfWaterUse" slot-scope="text">
        {{ text === 0 ? '居民用水' : text === 1 ? '非居民用水' : text === 2 ? '特种用水' : '--' }}
      </a-tag>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleRevert([record.id])"> <a-icon type="redo" />还原 </a>
        <a-divider type="vertical" />
        <a @click="handleDelete([record.id])"> <a-icon type="delete" />清理 </a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import moment from 'moment'

export default {
  name: 'WaterMeterRecycleBinModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    bookObj: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    moment(date) {
      if (!date) return '--'
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  data() {
    return {
      title: '数据回收站',
      loading: false,
      innerVisible: false,
      selectedRowKeys: [],
      dataSource: [],
      query: {
        userNo: '',
        classNo: '',
        appearanceNo: ''
      },
      columns: [
        {
          title: '片区名称',
          dataIndex: 'zoneName',
          width: 120
        },
        {
          title: '表册号',
          dataIndex: 'bookId',
          width: 100,
          scopedSlots: { customRender: 'bookId' }
        },
        {
          title: '用户编码',
          dataIndex: 'userNo',
          width: 120
        },
        {
          title: '分类编码',
          dataIndex: 'classNo',
          width: 120
        },
        {
          title: '水表编号',
          dataIndex: 'appearanceNo',
          width: 120
        },
        {
          title: '用户名称',
          dataIndex: 'userNikeName',
          width: 150
        },
        {
          title: '通信编号',
          dataIndex: 'commNumber',
          width: 120
        },
        {
          title: '用户地址',
          dataIndex: 'address',
          width: 200
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          width: 120
        },
        {
          title: '管理分表户数',
          dataIndex: 'householdCount',
          width: 120
        },
        {
          title: '用水性质',
          dataIndex: 'natureOfWaterUse',
          width: 100,
          scopedSlots: { customRender: 'natureOfWaterUse' }
        },
        {
          title: '安装时间',
          dataIndex: 'installDate',
          width: 120
        },
        {
          title: '口径',
          dataIndex: 'caliber',
          width: 80
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          width: 100
        },
        {
          title: '类型',
          dataIndex: 'type',
          width: 100
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 80
        },
        {
          title: '用户用水类型',
          dataIndex: 'waterBigStatus',
          width: 120,
          scopedSlots: { customRender: 'waterBigStatus' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '删除时间',
          dataIndex: 'updateTime',
          width: 160,
          scopedSlots: { customRender: 'updateTime' }
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        // 回收站操作，get = 获取列表；put = 取回；delete = 彻底删除
        recycleBin: '/pipe-network/gis_class_user_water_meters/hs/page',
        putRecycleBin: '/pipe-network/gis_class_user_water_meters/select/update',
        postRevertAll: '/pipe-network/gis_class_user_water_meters/select/hs/update', // 一键还原
        deleteRecycleBin: '/pipe-network/gis_class_user_water_meters/select/hs/delete', // 一键清空回收站
        deleteBatchRecycleBin: '/pipe-network/gis_class_user_water_meters/select/true/delete' // 批量删除
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200']
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData()
        }
        this.innerVisible = val
      }
    },
    innerVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    // 一键还原
    revertAll() {
      this.$confirm({
        title: '一键还原',
        content: `您确定要还原回收站中的所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http
            .post(this.url.postRevertAll)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('一键还原成功')
                this.loadData()
                this.handleClearSelection()
                this.$emit('ok')
              } else {
                this.$message.warning(res.message || '还原失败')
              }
            })
            .catch((error) => {
              this.$message.error('一键还原失败：' + (error.message || error))
            })
        }
      })
    },
    // 一键清空回收站
    clearUp() {
      this.$confirm({
        title: '清空回收站',
        content: `您确定要清空回收站吗？`,
        centered: true,
        onOk: () => {
          this.$http
            .delete(this.url.deleteRecycleBin)
            .then((res) => {
              if (res.code === 0) {
                this.$message.success('操作成功')
                this.loadData()
              } else {
                this.$message.warning(res.message || '操作失败')
              }
            })
            .catch((error) => {
              this.$message.error('清空回收站失败：' + (error.message || error))
            })
        }
      })
    },
    // 重置
    resetList() {
      this.query.userNo = ''
      this.query.classNo = ''
      this.query.appearanceNo = ''
      this.selectedRowKeys = []
      this.pagination.current = 1
      this.loadData()
    },
    pageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.query
      }
      this.$http
        .get(this.url.recycleBin, {
          params
        })
        .then((res) => {
          if (res.code === 0) {
            this.pagination.total = res.data.total ? parseInt(res.data.total) : 0
            this.dataSource = res.data.list || []
          } else {
            this.$message.warning(res.message || '查询失败')
          }
        })
        .catch((e) => {
          this.$message.warning('查询已删除的数据失败：' + (e.message || e))
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOk() {
      this.loadData()
      this.$emit('ok')
    },
    handleCancel() {
      this.innerVisible = false
    },
    // 还原数据
    handleRevert(userIds) {
      this.$confirm({
        title: '恢复数据',
        content: `您确定要恢复这 ${userIds.length} 条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http
            .put(this.url.putRecycleBin, [...userIds])
            .then((res) => {
              if (res.code === 0) {
                this.handleOk()
                this.handleClearSelection()
                this.$message.success(`还原 ${userIds.length} 个数据成功！`)
              } else {
                this.$message.warning(res.message || '还原失败')
              }
            })
            .catch((error) => {
              this.$message.error('还原失败：' + (error.message || error))
            })
        }
      })
    },
    // 彻底删除数据
    handleDelete(userIds) {
      this.$confirm({
        title: '彻底删除数据',
        content: (
          <div>
            <p>您确定要彻底删除这 {userIds.length} 个数据吗？</p>
            <p style="color:red;">注意：彻底删除后将无法恢复，请谨慎操作！</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          this.$http
            .delete(this.url.deleteBatchRecycleBin, { data: userIds })
            .then((res) => {
              if (res.code === 0) {
                this.loadData()
                this.handleClearSelection()
                this.$message.success(`彻底删除 ${userIds.length} 条数据成功！`)
              } else {
                this.$message.warning(res.message || '删除失败')
              }
            })
            .catch((error) => {
              this.$message.error('删除失败：' + (error.message || error))
            })
        }
      })
    },
    handleRevertBatch() {
      this.handleRevert(this.selectedRowKeys)
    },
    handleDeleteBatch() {
      this.handleDelete(this.selectedRowKeys)
    },
    handleClearSelection() {
      this.handleTableSelectChange([], [])
    },
    handleTableSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    }
  }
}
</script>

<style lang="less" scoped></style>
